/* eslint no-param-reassign: "error" */

export default [
  {
    id: 'lundi',
    content: `
    Lundi, 11 h 55. Vous pensez déjà à votre déjeuner et salivez d’avance
    à l’idée de ces pâtes aux truffes bien méritées. Votre manager vous annonce qu’Émilie,
    l’une des chefs de projet de votre équipe, sera absente cette semaine.
    Il propose que chaque membre de l’équipe reprenne une partie de ses projets en cours.
    Naturellement, votre manager en prendra un peu plus à sa charge. Comment réagissez-vous ?
    `,
    choices: ['tuile', 'mal', 'superman'],
  },
  {
    id: 'tuile',
    optionText: `« Oh, la tuile… Ok, je vois comment je peux organiser ma semaine pour me concentrer sur
    l’essentiel et dégager du temps. À combien estimes-tu le temps nécessaire pour cette tâche ? »`,
    content: `
    Quelle réactivité ! Non seulement, vous proposez une gestion du temps intelligente, mais vous
    préparez le terrain en fonction de vos disponibilités ! Grâce à cela, vous ne vivrez pas cet
    aménagement d’emploi du temps comme une surcharge. Vous entamez bien ce jeu ! Attention toutefois
    à toujours repartir de la priorisation de vos tâches. Ici il vous faudra revoir vos priorités, et
    évaluer le vrai degré de priorité de chaque mission d’Émilie.
    [Découvrir la suite de la semaine](@mercredi)
    `,
  },
  {
    id: 'mal',
    optionText: `« Ah, ça tombe vraiment mal… Je vais regarder le temps qu'il me reste quand j'aurai
    fini toutes mes tâches déjà… Je te redis ça peut-être demain ou mercredi… »`,
    content: `
    Votre réponse est un peu vague, et à vous écouter, le problème ne semble pas vous concerner.

    Imaginons que vous puissiez corriger le tir. Que proposeriez-vous ?
    `,
    choices: ['opendata', 'lune', 'retard'],
  },
  {
    id: 'opendata',
    optionText: `« Je devrais préciser, c’est la dernière ligne droite du projet OpenData, il me reste
    encore beaucoup à faire. »`,
    content: `
    Voilà une réponse plus concrète ! Votre manager d’équipe a désormais les clés pour mieux comprendre votre
    indisponibilité et pourra mieux ajuster votre charge de travail.
    [Découvrir la suite de la semaine](@mercredi)
    `,
  },
  {
    id: 'lune',
    optionText: `« Enfin, je vois que ça va être problématique… Quand souhaites-tu avoir un retour sur
    les tâches à reprendre ? Je ne veux pas te promettre la Lune et ne pas pouvoir tenir les délais ! »`,
    content: `
    Vous faites preuve de beaucoup plus d’empathie, bravo ! Vos efforts pour vous mettre à la place de votre
    interlocuteur vont certainement l’adoucir.
    [Découvrir la suite de la semaine](@mercredi)
    `,
  },
  {
    id: 'retard',
    optionText: `« Oui, c’est vrai, j’ai pris un peu de retard ! Dis-toi que si je m’y mets avec vous, je
    vais empirer les choses. Mais la prochaine fois, vous pourrez vous venger sur moi ! »`,
    content: `
    Promettre à son manager une vengeance future n’est peut-être pas la bonne solution… Au moins, vous avez
    admis à demi-mot que vous avez été un peu trop loin.
    [Découvrir la suite de la semaine](@mercredi)
    `,
  },
  {
    id: 'superman',
    optionText: '« N’en dis pas plus, je suis sur le coup ! »',
    content: `
    Votre enthousiasme est digne d’un{% if isWoman %}e{% endif %} super-héros, mais attention à ce que vous
    acceptez ! Même si votre manager adopte la bonne attitude, réfléchissez toujours à la gestion de votre
    temps avant de formuler des promesses hâtives ! Personne n’a intérêt à vous mettre en difficulté.
    [Découvrir la suite de la semaine](@mercredi)
    `,
  },
]
